<template>
  <div>
    <Carousel
      arrow="always"
      autoplay
      dots="none"
      :autoplay-speed="speed"
      v-model="startInd"
      v-if="street.length"
      @on-change="changePage"
    >
      <CarouselItem  @click="$router.go(-1)" v-for="(item, index) in street" :key="index" :style="{width:Width+'px',height: Height+'px'}">
        <monitor-item :index="index" :street="item"></monitor-item>
      </CarouselItem>
    </Carousel>
  </div>
</template>
<script>
  import MonitorItem from './congtaiMonitorItem'
  export default {
    name: 'congtaiMonitor',
    components:{
      MonitorItem
    },
    data () {
      return {
        shequList:[1,2],
        Height: window.document.body.offsetHeight,
        Width: window.document.body.offsetWidth,
        startInd:0,
        street:[],
        speed:10000,
        scrollSettime:''
      }
    },
    watch:{
      startInd () {
        if (this.startInd == this.street.length -1) {
          this.scrollSettime = setTimeout(() => {
            this.startInd = 0
          },this.speed)
        }else {
          clearTimeout(this.scrollSettime)
        }
      }
    },
    methods:{
      getToken () {
        // var areaId = '659002000000'
        var areaId
          if (location.href.indexOf('ceshi')>-1) {
          areaId  = 110105000000
        }else if (location.href.indexOf('yanfa')>-1 || location.href.indexOf('localhost') >-1 ) {
          areaId = 659002000000
          //   areaId  = 130403000000  //正式
        }else {
          areaId  = 130403000000  //正式
        }
        var url = this.urlobj.getCTToken+'?areaId='+areaId
        this.$get(url).then(res => {
          //现场只要从东，光明桥，和平
          //四季青也不要了四季青，130403006000,
          let area ='130403005000,130403004000,130403007000'
          let data = res.rows
          if(areaId == 130403000000) data = data.filter(item=>area.indexOf(item.streetId)>-1)
          this.street = data.map(item => {
            return {
              name:item.streetName,
              token:item.token
            }
          })
        })
      },
      changePage (oldValue, value) {
        this.startInd = value
      },
      swiperChange (type) {
        //0左面翻页，1右面翻页
        // 总页数
        var total = this.street.length
        if (type == 'left') {
          if (this.startInd == total - 1) return
          this.startInd ++
        }else if (type == 'right') {
          if (this.startInd == 0) return
          this.startInd --
        }else if (type == 'goback') {
          window.open('https://ceshi.shequyun.cn/#/moduleList','_self')
        }else if (type == 'reload') {
          location.reload()
        }
      }
    },
    mounted () {
      this.getToken()
      window.btnclick = this.swiperChange
    }
  }
</script>

<style scoped>

</style>
